// stories
import FrontCover from "./pageContent/FrontCover";
import WelcomePage from "./pageContent/Welcome";
import GuaranteedOrigins from "./pageContent/GuaranteedOrigins";
import TrustAndTransparency from "./pageContent/TrustAndTransparency";
import SilverLining from "./pageContent/SilverLining";
import FairTradeHighGrowth from "./pageContent/FairTradeHighGrowth";
import HighGrowthCulture from "./pageContent/HighGrowthCulture";
import MomentsOfPleasure from "./pageContent/MomentsOfPleasure";
import BackCover from "./pageContent/BackCover";

const state = {
  baseUrl: "/webfolder/assets/ebook/ytt-magazine/issue-2/ar/",
  navigationDirection: 1,
  pageContent: [
    FrontCover,
    WelcomePage,
    GuaranteedOrigins,
    TrustAndTransparency,
    SilverLining,
    FairTradeHighGrowth,
    HighGrowthCulture,
    BackCover
  ],
  activeContent: null,
  currentPage: 1,
  managingCookies: false,

  // to intercept back/forward browser clicks
  navigatingPages: false,
  readingContent: false,
  closeContent: false
};

export default state;
